import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { queryClient } from 'app/services/reactQuery';
import { PRICING_CATALOG_OFFERS_QUERY_KEY } from 'app/services/pricingCatalog/queryKeys';

const SUBSCRIPTION_REFRESH_TIMEOUT_MS = 15_000;

export type RefreshedSubscriptionStatus =
  | {
      regularization?: {
        canRegularize?: boolean;
        canRegularizeWithCard?: boolean;
        reason?: string | null;
      };
    }
  | undefined;

export function useRefreshSubscriptionStatus() {
  const dispatch = useDispatch();

  return useCallback(
    (): Promise<RefreshedSubscriptionStatus> =>
      new Promise((resolve) => {
        let settled = false;

        const finish = (data: RefreshedSubscriptionStatus) => {
          if (settled) {
            return;
          }

          settled = true;
          queryClient.invalidateQueries({ queryKey: PRICING_CATALOG_OFFERS_QUERY_KEY });
          resolve(data);
        };

        const timeoutId = window.setTimeout(
          () => finish(undefined),
          SUBSCRIPTION_REFRESH_TIMEOUT_MS,
        );

        dispatch({
          type: 'LOAD_SUBSCRIPTION_STATUS',
          payload: {
            onSettle: (data: RefreshedSubscriptionStatus) => {
              window.clearTimeout(timeoutId);
              finish(data);
            },
          },
        });
      }),
    [dispatch],
  );
}
